import { Modal } from '@/components/Modal'

import { modalId } from '../hooks/useController'
import { Content } from './Content'
import { ExportOrderSource } from '..'

type Props = {
  source: ExportOrderSource
}

export function Root(props: Props) {
  return (
    <Modal modalId={modalId}>
      <Content source={props.source} />
    </Modal>
  )
}
